export default theme => ({
	cellStyle: {
		fontSize: 14,
		fontFamily: "NotoSans-Regular",
		padding: "10px",
		textAlign: "center",
		color: theme.palette.secondary.contrast,
	},
});
